import { render, staticRenderFns } from "./SailCroatiaBody.vue?vue&type=template&id=2651a600&scoped=true&"
import script from "./SailCroatiaBody.vue?vue&type=script&lang=ts&"
export * from "./SailCroatiaBody.vue?vue&type=script&lang=ts&"
import style0 from "./SailCroatiaBody.vue?vue&type=style&index=0&id=2651a600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2651a600",
  null
  
)

export default component.exports